import api from 'utils/api';
import firebase from 'utils/auth/firebase';

export const getMediaKey = async (url) => {
  const userId = await firebase?.auth()?.currentUser?.uid;

  return api.get(`${url}?user_id=${userId}`).then((response) => response?.data ?? {});
};
